var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useCallback } from 'react';
import { WeeklySchedule } from '../WeeklySchedule';
import { useEventTypeMapping } from './hooks/useEventTypeMapping.web';
import { logger } from '@amzn/atoz-shiftapp-metrics';
import { DateTime } from 'luxon';
import { useSearchParams } from 'react-router-dom';
import { useDynamicTranslation } from '../../../hooks/useDynamicTranslation';
import { useAssociateContext } from '@amzn/atoz-shiftapp-utilities';
import { SpinnerOverlay } from '../SpinnerOverlay';
import { WeeklyScheduleViewErrorBoundary as ErrorBoundary } from './WeeklyScheduleViewErrorBoundary';
export var WEEKLY_SCHEDULE_ERROR_LOG_PREFIX = 'WeeklyScheduleError ';
export var WeeklyScheduleView = function (_a) {
    var selectedDate = _a.selectedDate, updateDateAction = _a.updateDateAction, scheduleShifts = _a.scheduleShifts, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var _c = useDynamicTranslation(), dt = _c.dt, t = _c.t;
    var _d = useSearchParams(), searchParams = _d[0], setSearchParams = _d[1];
    var associateInfo = useAssociateContext().associateInfo;
    var _e = useEventTypeMapping(), eventTypeMapping = _e.eventTypeMapping, fallbackEventDetails = _e.fallbackEventDetails;
    var onChangeAction = function (newDate) {
        (newDate === null || newDate === void 0 ? void 0 : newDate.isValid) &&
            setSearchParams(__assign(__assign({}, Object.fromEntries(searchParams)), { date: newDate.toISODate() }), {
                replace: true
            });
        updateDateAction(newDate);
    };
    var shiftIntervalEvents = useMemo(function () {
        if (!scheduleShifts)
            return [];
        var shiftIntervalEvents = [];
        scheduleShifts.forEach(function (scheduleShift) {
            if (scheduleShift.shiftIntervals) {
                scheduleShift.shiftIntervals.forEach(function (_a) {
                    var category = _a.category, timeRange = _a.timeRange, name = _a.name;
                    var shiftIntervalEvent = {
                        id: "".concat(category, ":").concat(timeRange.start, "-").concat(timeRange.end),
                        collectionId: scheduleShift.shift.id,
                        name: dt(name),
                        type: category,
                        startTime: DateTime.fromISO(timeRange.start),
                        endTime: DateTime.fromISO(timeRange.end)
                    };
                    shiftIntervalEvents.push(shiftIntervalEvent);
                });
            }
        });
        return shiftIntervalEvents;
    }, [scheduleShifts]);
    var emitWeeklyScheduleErrorLog = useCallback(function (message, context) {
        logger.error(WEEKLY_SCHEDULE_ERROR_LOG_PREFIX + message, context);
    }, []);
    return (React.createElement(ErrorBoundary, null,
        React.createElement(SpinnerOverlay, { isLoading: isLoading },
            React.createElement(WeeklySchedule, { events: shiftIntervalEvents, eventTypeMapping: eventTypeMapping, fallbackEventDetails: fallbackEventDetails, emitErrorLog: emitWeeklyScheduleErrorLog, locale: associateInfo.locale, timeZone: associateInfo.timeZone, selectedDate: selectedDate, updateDateAction: onChangeAction, nextWeekAriaLabel: t('ess_shifts_dashboard_weeklySchedule_nextButton'), prevWeekAriaLabel: t('ess_shifts_dashboard_weeklySchedule_prevButton') }))));
};
